import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit {

  @Input() public accordionTitle!: string;
  @Input() public isDown: boolean = false;

  public readonly accordionId: string;

  constructor() {
    this.accordionId = crypto.randomUUID();
  }

  ngOnInit(): void {
  }

}
